<template>
  <!-- 开关锁记录 -->
  <div class="module-info">
    <div class="search">
      <el-form
        ref="form"
        :model="searchParams"
        label-width="auto"
        class="from"
        size="small"
      >
        <el-form-item :label="$t('pages.equipment.text176')">
          <el-select
            v-model="searchParams.commandType"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option :label="$t('pages.equipment.text136')" value="0">
            </el-option>
            <el-option :label="$t('pages.equipment.text135')" value="1">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text177')">
          <el-select
            v-model="searchParams.lockCtrlType"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option :label="$t('pages.equipment.text178')" value="2">
            </el-option>
            <el-option label="IoT" value="1"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text52')">
          <el-date-picker
            v-model="searchParams.startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            :picker-options="pickerOptions0"
            @change="startChange"
          >
          </el-date-picker>
          <span style="margin: 0 14px">-</span>
          <el-date-picker
            v-model="searchParams.stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton type="search" @click="search"></DiluButton>
        <DiluButton type="reset" @click="reset"></DiluButton>
      </div>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :total="total"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
    >
      <el-table-column prop="date" label="#" width="40" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="commandType"
        :label="$t('pages.equipment.text176')"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.commandType == 0
              ? $t("pages.equipment.text136")
              : $t("pages.equipment.text135")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="appAccount"
        :label="$t('pages.user.text5')"
        width="160"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="appCode"
        :label="$t('pages.equipment.text179')"
        width="140"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        :label="$t('pages.equipment.text177')"
        width="140"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.lockCtrlType == 2 ? $t("pages.equipment.text178") : "IoT"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="result"
        :label="$t('pages.equipment.text180')"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <div v-for="item in resultList" :key="item.value">
            <span v-if="item.value == scope.row.result">{{ item.label }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('pages.equipment.text181')"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="lookAddr(scope.row)">{{
            $t("button.look")
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="commandStartTime"
        :label="$t('pages.equipment.text182')"
        width="200"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="commandStopTime"
        :label="$t('pages.equipment.text183')"
        width="200"
        align="center"
      >
      </el-table-column>
    </DiluTable>

    <LookAddr
      :addrVisible="addrVisible"
      @addrClose="addrClose"
      :phoneAddr="phoneAddr"
      :bikeAddr="bikeAddr"
    />
  </div>
</template>

<script>
import DiluTable from "../../../../components/pubilc/dilu-table.vue";
import DiluButton from "../../../../components/pubilc/dilu-button.vue";
import LookAddr from "./lookAddr.vue";
import { resetDate } from "../../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.searchParams.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      addrVisible: false,
      tableConfig: {
        isTree: false,
        isTreeText: "id",
        isPage: true,
      },
      resultList: [
        {
          value: 0,
          label: this.$t("pages.equipment.text184"),
        },
        {
          value: 1,
          label: this.$t("pages.equipment.text185"),
        },
        {
          value: 2,
          label: this.$t("pages.equipment.text186"),
        },
        {
          value: 3,
          label: this.$t("pages.equipment.text187"),
        },
      ],
      searchParams: {
        bikeCode: "",
        commandType: "", //指令类别
        lockCtrlType: "", //控制方式
        startAt: "", //查询开始时间
        stopAt: "", //查询结束时间
        pageNum: 1,
        pageSize: 10,
      },
      bikeAddr: [],
      phoneAddr: [],
      total: 0,
      tableData: [],
      isSerch: false, //是否在查询
    };
  },
  components: {
    DiluTable,
    DiluButton,
    LookAddr,
  },
  watch: {
    activeName(newValue) {
      if (newValue == "SwitchLockRecord") {
        this.getLockRecordByBikeCode();
      }
    },
  },
  props: ["activeName", "info", "bikeCode"],
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.getLockRecordByBikeCode();
    },
    startChange() {
      this.searchParams.stopAt = null;
    },
    addrClose() {
      this.addrVisible = false;
    },
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams = {
          bikeCode: this.bikeCode,
          commandType: "", //指令类别
          lockCtrlType: "", //控制方式
          startAt: "", //查询开始时间
          stopAt: "", //查询结束时间
          pageNum: 1,
          pageSize: 10,
        };
      }
      this.searchParams.pageNum = e;
      this.getLockRecordByBikeCode();
    },
    lookAddr(e) {
      this.addrVisible = true;
      let phoneAddr = e.phoneLocation.split(",");
      let bikeAddr = e.bikeLocation.split(",");
      this.phoneAddr = [parseFloat(phoneAddr[1]), parseFloat(phoneAddr[0])];
      this.bikeAddr = [parseFloat(bikeAddr[1]), parseFloat(bikeAddr[0])];
    },
    //重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams = {
        bikeCode: this.bikeCode,
        commandType: "", //指令类别
        lockCtrlType: "", //控制方式
        startAt: "", //查询开始时间
        stopAt: "", //查询结束时间
        pageNum: 1,
        pageSize: 10,
      };
      this.getLockRecordByBikeCode();
    },
    //开关锁记录
    getLockRecordByBikeCode() {
      this.searchParams.bikeCode = this.bikeCode;
      if (this.searchParams.stopAt && this.searchParams.startAt) {
        this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 结束时间
        this.searchParams.startAt = resetDate(this.searchParams.startAt); // 开始时间
      }
      if (this.searchParams.startAt) {
        if (!this.searchParams.stopAt) {
          return this.$message.error(this.$t("public.text3"));
        }
      }
      if (this.searchParams.stopAt) {
        if (!this.searchParams.startAt) {
          return this.$message.error(this.$t("public.text2"));
        }
      }
      let str = "?";
      for (let i in this.searchParams) {
        if (this.searchParams[i]) {
          str = str + i + "=" + this.searchParams[i] + "&";
        }
      }
      this.request.getLockRecordByBikeCode(str).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
  },
};
</script>

<style scoped>
.module-info {
  padding: 20px 10px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.searchSubmit {
  float: right;
  display: flex;
}
</style>